import * as React from "react";
import { Style, StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { LifeChangingEventCell } from "source/app/presentation/MainPanel/LifeChangingEvents/LifeChangingEvents";

export function LCEPerspective({ perspective }: { perspective: number }) {
    return (
        <span>
            {perspective}
            <span
                {...Style(`lcePerspectiveSuffix`, {
                    opacity: 0.5,
                    fontSize: "10px",
                    position: `relative`,
                    top: `2px`,
                })}
            >
                pp
            </span>
        </span>
    );
}
